export default __webpack_public_path__ + "static/beatbugs-2-d-14b618d5124cad933d16bf8207f6e489.webp";